import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { SegmentsRepository } from '@core/repositories/segments.repository';
import { Segment } from '@shared/interfaces/segment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiSegmentsRepository implements SegmentsRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.appConfig.SERVICES.segments.findall.url);
  }

  add(segment: Segment): Observable<any> {
    const data = {
      data: {
        id: segment.id,
        type: 'Segment',
        attributes: {
          name: segment.name
        }
      }
    };
    return this.http.post(this.appConfig.SERVICES.segments.add.url, data);
  }

  edit(segment: Segment): Observable<any> {
    const data = {
      data: {
        id: segment.id,
        type: 'Segment',
        attributes: {
          name: segment.name
        }
      }
    };
    return this.http.put(this.appConfig.SERVICES.segments.update.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(
      this.appConfig.SERVICES.segments.delete.url + '/' + item
    );
  }
}
